var map = {
	"./ch.json": "503f",
	"./en.json": "e312",
	"./fr.json": "b16e",
	"./gr.json": "510a",
	"./it.json": "669f",
	"./ru.json": "3a06",
	"./sp.json": "1811",
	"./vi.json": "088e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3f5a";